// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import util from '@/utils/util'
import request from '@/utils/request'
import store from './store'
import {
  VueAxios
} from './utils/request'

// import './theme/diyElement.scss'


// 富文本图片拖拽缩放
import VueQuillEditor, {
  Quill
} from 'vue-quill-editor'
import imageResize from 'quill-image-resize-module' // 调整大小组件。
import {
  ImageDrop
} from 'quill-image-drop-module' // 拖动加载图片组件。
Quill.register('modules/imageResize', imageResize)
Quill.register('modules/imageDrop', ImageDrop)
Vue.use(VueQuillEditor)

// 工具函数导入
Object.keys(util).map((v) => {
  if (!Vue.prototype[v]) {
    Vue.prototype[v] = util[v]
  } else {
    throw new Error(`试图在给Vue的原型添加属性时候出现冲突,具体方法名为${v}`)
  }
})

Vue.prototype.$http = request

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueAxios)
Vue.prototype.request = request.request
// Vue.prototype.BATCH_COMMON_URL = "http://localhost:10010/";
Vue.prototype.baseURL = request.baseURL
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// echarts
import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts



// WEBPACK FOOTER //
// ./src/main.js